module.exports = __webpack_public_path__ + "static/WEDDING E&M-155-0b23a393341050fdfef384a524996626.jpg";